import { render } from "./RecuperarPasswordForm.vue?vue&type=template&id=223e7041&scoped=true"
import script from "./RecuperarPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecuperarPasswordForm.vue?vue&type=script&lang=js"

import "./RecuperarPasswordForm.vue?vue&type=style&index=0&id=223e7041&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223e7041"]])

export default __exports__